import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CompanySettingService } from '../Service/company-setting.service';
import { CommonService } from '../Service/common.service';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  Address: string = environment.address;
  ContactNo: string = environment.mobileNo;
  ContactEmail: string = environment.emailId;
  companysname: string = environment.companyShortName;
  companyfname: string = environment.companyFullName;
  timeOut: number = 0;
  form: FormGroup;
  errorMessage: string;
  CompanySetting = CompanySettingService;
  constructor(private readonly commonService: CommonService, private readonly toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      firstname: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(40),
        Validators.pattern(/^[a-zA-Z ]*$/),
      ]),
      lastname: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(40),
        Validators.pattern(/^[a-zA-Z ]*$/),
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.email,
      ]),
      mobile: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/),
      ]),
      reply: new FormControl('', [
        Validators.required
      ]),
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.toastr.warning('Please fill form correctly.');
      return;
    }

    const formData = this.form.value;
    const requestModel = {
      "UserRQ": {
        "Authentication": {
          "AuthenticationKey": 'AB82D7A7-A4E4-4F9D-B950-9A6C9EC1C612',
          "CompanyId": this.CompanySetting.CompanyCode,
          "IPAddress": "",
          "ChannelCode": this.CompanySetting.Channel,
          "DomainUrl": '',
        },
        "RequestHeader": {
          "Method": 'usercontactus',
          "Culture": 'en',
        },
        "RequestBody": {
          "ContactUs": {
            "FirstName": formData.firstname,
            "Title": 'Mr.',
            "MiddleName": 'kr',
            "LastName": formData.lastname,
            "MobileNo": formData.mobile,
            "Email": formData.email,
            "QuerySubject": "Contact use Query",
            "QueryMessage": "testing here",
            "PageContent": "",

          },
        },
      },
    };
    this.commonService.UserContactUs(requestModel).subscribe(
      (response) => {
        this.toastr.success('Form submission successful!')
      },
      error => {
        this.toastr.error("Failed to submit the form. Please try again later.")
      }
    );
    this.form.reset();
  }
}
